import type { SVGProps } from "react";
export default function CloseSvg(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
      className="flex shrink-0 grow-0"
      {...props}
    >
      <path
        stroke="#2B2929"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m12 4-8 8m0-8 8 8"
      />
    </svg>
  );
}
